import React, { useState } from 'react';
import { connect } from 'react-redux';
import { datasetUrl } from '@/constants/urls';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { confirmDatasetDeletion } from '../actions';
import { datasetAdminPermissions } from '../sharing/constants';
import DatasetTools from './DatasetTools';

const DatasetToolsMenu = ({
  allowDelete,
  dataset,
  listItem = false,
  showDelete,
  upward,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <StandardToolsMenu
      allowDelete={allowDelete}
      allowRead
      href={datasetUrl(dataset, '#')}
      listItem={listItem}
      onChange={setOpen}
      onDelete={() => showDelete(dataset)}
      open={open}
      upward={upward}
    >
      {open && (<DatasetTools dataset={dataset} />)}
    </StandardToolsMenu>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { destroy } } } },
}, { dataset }) => ({
  allowDelete: destroy && dataset.permissions[datasetAdminPermissions.DESTROY],
});

const mapDispatchToProps = {
  showDelete: confirmDatasetDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetToolsMenu);
